import { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Box } from '@mui/system';
import { Alert } from '@mui/material';
import PaginationControlledAdvanced from './PaginationControlledAdvanced';
import CSVReport from './CSVReport';
import CSVconLLU from "./CSVconLLU";
import Stack from "@mui/material/Stack";





export default function Advanced({data}) {
    
    const [advancedQueryResult, setAdvancedQueryResult] = useState([]);
    const [message, setMessage] = useState(''); 
    const [transcription, setTranscription] = useState('dip');
    const [lemma, setLemma] = useState('');
    const [annotation, setAnnotation] = useState('');
    const [UD, setUD] = useState('');
    const [UDOfParent, setUDOfParent] = useState('');


    const handleChangeTranscription = (event) => {setTranscription(event.target.value)};
    function handleChangeLemma(e) {setLemma(e.target.value)};


     function poSSelect(e) {

        const opt = document.getElementsByClassName("opt");
        for (let i = 0; i < opt.length; i++) {
			opt[i].style.display = "none";
			opt[i].classList.remove("act");
		}

        const a = document.getElementById(e.target.value);

        if (a) {
            a.style.display = "";
		a.classList.add("act");
        }
	}


    	function poSWrite(e) {
            e.preventDefault()
            let pos = document.getElementById("PoS").value;
            if (pos !== "" ) {
                document.getElementById("inputAnnot").value = pos;

            let tags = document.getElementsByClassName("act")[0]
                if (tags !== undefined) {
                    tags = tags.getElementsByClassName("tag")
                }

            if (tags !== undefined) {
			for (let i = 0; i < tags.length; i++) {
				pos += tags[i].value;
			}
			document.getElementById("inputAnnot").value = pos;
		    }
            }

            let queryString = pos
            if (queryString.includes('?')) {
                  queryString = pos.replaceAll('?', '.');
            }

        setAnnotation(queryString)
	}



    function handleChangeAnnotation(event) {
         let queryString = event.target.value;
        if (event.target.value.includes('?')) {
            queryString = event.target.value.replace('?', '.');
            queryString += ".*"
        }
        setAnnotation(queryString);
    }


           function uDSelect1(e) {
        let opt = document.getElementsByClassName("opt1");

       for (let i = 0; i < opt.length; i++) {
			opt[i].style.display = "none";
			opt[i].classList.remove("act1");

		}

        const a = document.getElementById(e.target.value);

        if (a) {
            a.style.display = "";
		    a.classList.add("act1");

        }
	}

                function uDWrite1(e) {
            e.preventDefault()
            let ud = document.getElementById("UD").value;
            if (ud !== "" ) {
                document.getElementById("inputUD").value = ud;

            let tags = document.getElementsByClassName("act1")[0]
                if (tags !== undefined) {
                    tags = tags.getElementsByClassName("tag1")
                }

            if (tags !== undefined) {
			for (let i = 0; i < tags.length; i++) {
				ud += tags[i].value;
			    }
			document.getElementById("inputUD").value = ud;
            }
            }

            let queryString = ud;
            if (queryString.includes(':?')) {
                  queryString = ud.replaceAll(':?', '.*');
                }
        setUD(queryString)
	        }


         function handleChangeUD(event) {
         let queryString = event.target.value;
        if (event.target.value.includes(':?')) {
            queryString = event.target.value.replace(':?', '.*');
        }
        setUD(queryString);
    }




      function uDSelect2(e) {
    let opt2 = document.getElementsByClassName("opt2");
    for (let i = 0; i < opt2.length; i++) {
      opt2[i].style.display = "none";
      opt2[i].classList.remove("act2");
    }
    let z = e.target.value + "2";
    const a2 = document.getElementById(z);
    if (a2) {
      a2.style.display = "";
      a2.classList.add("act2");
    }
  }


  function uDWrite2(e) {
    e.preventDefault()
    let ud2 = document.getElementById("UD2").value;
    if (ud2 !== "" ) {
      document.getElementById("inputUD2").value = ud2;
      let tags2 = document.getElementsByClassName("act2")[0]
      if (tags2 !== undefined) {
        tags2 = tags2.getElementsByClassName("tag2")
      }
      if (tags2 !== undefined) {
        for (let i = 0; i < tags2.length; i++) {
          ud2 += tags2[i].value;
        }
        document.getElementById("inputUD2").value = ud2;
      }
    }
    let queryString = ud2;
    if (queryString.includes(':?')) {
      queryString = ud2.replaceAll(':?', '.*');
    }
    setUDOfParent(queryString)
  }



    function handleChangeUDOfParent(event) {
         let queryString = event.target.value;
        if (event.target.value.includes(':?')) {
            queryString = event.target.value.replace(':?', '.*');
        }
        setUDOfParent(queryString);
    };

    function handleSubmit(e) {
        e.preventDefault()
       
        let answer = []
        for (const text of data) {
          let token_index =  2
          const text_name = text['text']

          if (transcription === 'cyr') {
            token_index = 1
          } else if (transcription === 'lat') {
            token_index = 0
          }
  
  
          for (const [, sentence] of Object.entries(text['sentences'])) {
            
            let lemmata  = []
            let annotations = []
            let tokens = []
            let UDs = []
            let ordinals = []
            let ordinalsOfParents = []
            let sent_plain = ''
            let translation = ''
               let annotationsExt = [];
          let UDsOfParents = [];
          let sentID = null;
          let re = new RegExp(annotation);
  
              for (const word of sentence) {
                  sentID = word[6]
                sent_plain += word[token_index]
                sent_plain += ' ' 
                tokens.push(word[token_index])
                lemmata.push(word[3])
                annotations.push(word[4])
                ordinals.push(word[7])
                ordinalsOfParents.push(word[8])
                UDs.push(word[9]);

                UDsOfParents.push(word[8]);
              word[5] ? annotationsExt.push(word[5]) : annotationsExt.push('_');

                if (word[13]) {
                  translation += word[13]
                  translation += ' / '
                }      
                
              }

              function compareLemma (x, lemma) {

                if (lemma) {
                    return x === lemma
                } else {
                    return true
                }
              }

              function compareAnnot (x, annot) {

                if (annot) {
                    return (x.startsWith(annot) || x.match(re))
                } else {
                    return true
                }
              }

              function compareUD (x, UD) {

                if (UD) {
                    return x === UD
                } else {
                    return true
                }
              }


              function compareUDOfparent (x, UDofParent) {

                if (UDOfParent) {
                    return x === UDOfParent.toLowerCase()
                } else {
                    return true
                }
              }

              for (let i = 0; i < tokens.length; i++) {

                     const ordinalOfParent = ordinalsOfParents[i]
                    const parentIndex = ordinalOfParent - 1
                    const currentUDOfParent = UDs[parentIndex]

                if (compareAnnot(annotations[i], annotation) && compareLemma(lemmata[i], lemma) && compareUD(UDs[i], UD.toLowerCase())  && compareUDOfparent(currentUDOfParent, UDOfParent.toLowerCase())) {
               answer.push([sent_plain, text_name, tokens, lemmata, annotations, translation.slice(0, -2), UDs, i, annotationsExt, UDsOfParents, sentID ])
              }
              }

          }
        }
        setAnnotation(annotation)
        setLemma(lemma)
        setUD(UD)
        setMessage(`Your query has given ${answer.length} results.`)
        setAdvancedQueryResult(answer)
      }


    return (
        <>
               <Box sx={{ width: '100%' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={6}>

             <Stack direction={'column'}>
         <input   type='text'   placeholder="*Annotation" onChange={handleChangeAnnotation} style={{width: "30%"}} id='inputAnnot'/>
          <input   type='text'   placeholder="*UD" onChange={handleChangeUD}  style={{width: "30%", marginTop: "20px"}} id='inputUD' />
         <input   type='text'   placeholder="*UD of Parent" onChange={handleChangeUDOfParent} style={{width: "30%", marginTop: "20px"}} id='inputUD2'  />
         <input   type='text'   placeholder="*Lemma" onChange={handleChangeLemma} style={{width: "30%", marginTop: "20px"}}
         />

                         <select style={{width: "30%", marginTop: "20px"}}
          value={transcription}
          onChange={handleChangeTranscription}
        >
          <option value={'lat'}>Latin</option>
          <option value={'cyr'}>Cyrillic</option>
          <option value={'dip'}>Diplomatic</option>
        </select>

                 <button  type='submit'
                          style={{width: "80px", marginTop: "20px"}}
                          disabled={!annotation && !lemma && !UD && !UDOfParent} onClick={handleSubmit}>Submit</button>

             </Stack>

        </Grid>


        <Grid item xs={6}>
             <Stack direction={'column'}>
             <form id="tagger" >
                       <form>
                           <select id="PoS"    onChange={(e) => poSSelect(e)} >
                               <option value="">select word category</option>
                               <option value="N">noun</option>
                               <option value="A">adjective</option>
                               <option value="P">pronoun</option>
                               <option value="M">numeral</option>
                               <option value="V">verb</option>
                               <option value="R">adverb</option>
                               <option value="S">preposition</option>
                               <option value="C">conjunction</option>
                               <option value="Q">particle</option>
                               <option value="I">interjection</option>
                               <option value="X">punctuation</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="N">
                           <select className="tag">
                               <option value="?">any gender</option>
                               <option value="f">feminine</option>
                               <option value="m">masculine</option>
                               <option value="n">neuter</option>
                           </select>
                           <select className="tag">
                               <option value="?">any number</option>
                               <option value="s">singular</option>
                               <option value="d">dual</option>
                               <option value="p">plural</option>
                           </select>
                           <select className="tag">
                               <option value="?">any case form</option>
                               <option value="n">nominative (or nom/acc/inst)</option>
                               <option value="g">genitive (or gen/acc, gen/loc)</option>
                               <option value="d">dative (or dat/loc, dat/inst)</option>
                               <option value="a">accusative</option>
                               <option value="v">vocative</option>
                               <option value="l">locative</option>
                               <option value="i">instrumental</option>
                               <option value="o">vowel article (m.sg -o)</option>
                               <option value="o">oblique (f.sg -ь)</option>
                               <option value="o">other article (RO only)</option>
                           </select>
                           <select className="tag">
                               <option value="">unspecified animacy</option>
                               <option value="y">animate</option>
                               <option value="n">inanimate</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="A">
                           <select className="tag">
                               <option value="?">any gender</option>
                               <option value="f">feminine</option>
                               <option value="m">masculine</option>
                               <option value="n">neuter</option>
                           </select>
                           <select className="tag">
                               <option value="?">any number</option>
                               <option value="s">singular</option>
                               <option value="d">dual</option>
                               <option value="p">plural</option>
                           </select>
                           <select className="tag">
                               <option value="?">any case form</option>
                               <option value="n">nominative (or nom/acc/inst)</option>
                               <option value="g">genitive (or gen/acc, gen/loc)</option>
                               <option value="d">dative (or dat/loc, dat/inst)</option>
                               <option value="a">accusative</option>
                               <option value="v">vocative</option>
                               <option value="l">locative</option>
                               <option value="i">instrumental</option>
                               <option value="o">vowel article (m.sg -o)</option>
                               <option value="o">oblique (f.sg -ь)</option>
                           </select>
                           <select className="tag">
                               <option value="?">any complexity</option>
                               <option value="y">long-form</option>
                               <option value="n">short-form</option>
                           </select>
                           <select className="tag">
                               <option value="">no degree</option>
                               <option value="c">comparative</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="P">
                           <select className="tag">
                               <option value="?">any type</option>
                               <option value="d">demonstrative</option>
                               <option value="i">indefinite</option>
                               <option value="p">personal</option>
                               <option value="q">interrogative</option>
                               <option value="r">relative</option>
                               <option value="s">possessive (RO only)</option>
                               <option value="x">reflexive</option>
                               <option value="z">negative</option>
                           </select>
                           <select className="tag">
                               <option value="?">any person</option>
                               <option value="-">unspecified</option>
                               <option value="1">1</option>
                               <option value="2">2</option>
                               <option value="3">3</option>
                           </select>
                           <select className="tag">
                               <option value="?">any gender</option>
                               <option value="f">feminine</option>
                               <option value="m">masculine</option>
                               <option value="n">neuter</option>
                           </select>
                           <select className="tag">
                               <option value="?">any number</option>
                               <option value="s">singular</option>
                               <option value="d">dual</option>
                               <option value="p">plural</option>
                           </select>
                           <select className="tag">
                               <option value="">any case form</option>
                               <option value="n">nominative (or nom/acc)</option>
                               <option value="g">genitive (or gen/acc, gen/loc)</option>
                               <option value="d">dative (or dat/loc, dat/inst)</option>
                               <option value="a">accusative</option>
                               <option value="l">locative</option>
                               <option value="i">instrumental</option>
                               <option value="o">oblique (f.sg -ь)</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="V">
                           <select className="tag">
                               <option value="?">any type</option>
                               <option value="m">main</option>
                               <option value="a">auxiliary</option>
                           </select>
                           <select className="tag">
                               <option value="?">any mood/form</option>
                               <option value="i">indicative</option>
                               <option value="m">imperative</option>
                               <option value="n">infinitive</option>
                               <option value="o">conditional</option>
                               <option value="p">participle</option>
                               <option value="s">subjunctive (RO only)</option>
                           </select>
                           <select className="tag">
                               <option value="?">any tense</option>
                               <option value="-">unspecified</option>
                               <option value="p">present</option>
                               <option value="a">aorist</option>
                               <option value="i">imperfect</option>
                               <option value="l">pl.perfect (RO only)</option>
                           </select>
                           <select className="tag">
                               <option value="?">any person</option>
                               <option value="-">unspecified</option>
                               <option value="1">1</option>
                               <option value="2">2</option>
                               <option value="3">3</option>
                           </select>
                           <select className="tag">
                               <option value="?">any number</option>
                               <option value="s">singular</option>
                               <option value="d">dual</option>
                               <option value="p">plural</option>
                           </select>
                           <select className="tag">
                               <option value="">any aspect</option>
                               <option value="i">imperfective</option>
                               <option value="e">perfective</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="M">
                           <select className="tag">
                               <option value="">any type</option>
                               <option value="d">Arabic (digit)</option>
                               <option value="c">Cyrillic (alphabetic)</option>
                               <option value="r">Roman</option>
                               <option value="l">nominal</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="R">
                           <select className="tag">
                               <option value="">any degree</option>
                               <option value="c">comparative</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="S">
                           <select className="tag">
                               <option value="">any case (governed)</option>
                               <option value="g">genitive</option>
                               <option value="d">dative</option>
                               <option value="a">accusative</option>
                               <option value="l">locative</option>
                               <option value="i">instrumental</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="Q">
                           <select className="tag">
                               <option value="">any type</option>
                               <option value="c">comparative</option>
                               <option value="d">demonstrative</option>
                               <option value="g">general</option>
                               <option value="o">modal</option>
                               <option value="q">interrogative</option>
                               <option value="z">negative</option>
                           </select>
                       </form>

                       <br/><input className='submitBtn'
                                   type="submit" value="write PoS tag"
                                   onClick={(e) => poSWrite(e)}/>
                   </form>
             </Stack>

            <Stack direction={'column'}>
             <form id="tagger1">
              <form>
                  <select id="UD"  onChange= {(e) => uDSelect1(e)}  >
                      <option value="">select main dependency</option>
                      <option value="root">sentence root</option>
                      <option value="acl">adnominal clause root</option>
                      <option value="advcl">adverbial clause root</option>
                      <option value="advmod">adverbial modifier</option>
                      <option value="amod">adjectival modifier</option>
                      <option value="appos">appositional modifier</option>
                      <option value="aux">auxilla</option>
                      <option value="case">analytic dependency marker</option>
                      <option value="cc">coordinating conjunction</option>
                      <option value="conj">conjunct</option>
                      <option value="cop">copula</option>
                      <option value="csubj">subject of a subordinate sentence</option>
                      <option value="det">determiner</option>
                      <option value="discourse">discourse marker</option>
                      <option value="expl">expletive</option>
                      <option value="fixed">element of multiple word expression</option>
                      <option value="mark">subordinating conjunction/marker</option>
                      <option value="nsubj">subject of the main sentence</option>
                      <option value="nmod">nominal modifier</option>
                      <option value="nummod">numeric modifier</option>
                      <option value="obj">direct object</option>
                      <option value="obl">oblique argument</option>
                      <option value="orphan">orphaned element (no direct head)</option>
                      <option value="punct">punctuation</option>
                      <option value="reparandum">stricken tokens (reparanda)</option>
                      <option value="vocative">vocative element</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="obl">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":abl">ablative relation</option>
                      <option value=":iobj">indirect object/recipient relation</option>
                      <option value=":lat">allative relation</option>
                      <option value=":loc">static locative relation</option>
                      <option value=":poss">possessor relation</option>
                      <option value=":pred">predicative modifier</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="det">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":ext">extended adnominal demonstrative</option>
                      <option value=":p_nom">postnominal article</option>
                      <option value=":p_adj">postadjectival article</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="aux">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":con">conditional mood marker</option>
                      <option value=":fut">future tense marker</option>
                      <option value=":inf">infinitive clause marker</option>
                      <option value=":opt">optative clause marker</option>
                      <option value=":pass">passive voice marker</option>
                      <option value=":prf">perfect tense marker</option>
                      <option value=":pprf">plusquamperfect tense marker</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="fixed">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":con">conditional mood marker</option>
                      <option value=":fut">future tense marker</option>
                      <option value=":inf">infinitive clause marker</option>
                      <option value=":opt">optative clause marker</option>
                      <option value=":pass">passive voice marker</option>
                      <option value=":prf">perfect tense marker</option>
                      <option value=":pprf">plusquamperfect tense marker</option>
                  </select>
              </form>

              <form className="opt1" style={{display: "none"}} id="mark">
                  <select className="tag1">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":con">conditional mood marker</option>
                      <option value=":fut">future tense marker</option>
                      <option value=":inf">infinitive clause marker</option>
                      <option value=":opt">optative clause marker</option>
                      <option value=":pass">passive voice marker</option>
                      <option value=":prf">perfect tense marker</option>
                      <option value=":pprf">plusquamperfect tense marker</option>
                  </select>
              </form>
             <br/> <br/><input type="submit" value="write UD tag"   onClick={(e) => uDWrite1(e)}   />
          </form>
</Stack>



 <Stack direction={'column'} style={{marginTop: '15px'}}>
          <form id="tagger3">
              <form>
                  <select id="UD2"  onChange= {(e) => uDSelect2(e)}  >
                      <option value="">select main dependency</option>
                      <option value="root">sentence root</option>
                      <option value="acl">adnominal clause root</option>
                      <option value="advcl">adverbial clause root</option>
                      <option value="advmod">adverbial modifier</option>
                      <option value="amod">adjectival modifier</option>
                      <option value="appos">appositional modifier</option>
                      <option value="aux">auxilla</option>
                      <option value="case">analytic dependency marker</option>
                      <option value="cc">coordinating conjunction</option>
                      <option value="conj">conjunct</option>
                      <option value="cop">copula</option>
                      <option value="csubj">subject of a subordinate sentence</option>
                      <option value="det">determiner</option>
                      <option value="discourse">discourse marker</option>
                      <option value="expl">expletive</option>
                      <option value="fixed">element of multiple word expression</option>
                      <option value="mark">subordinating conjunction/marker</option>
                      <option value="nsubj">subject of the main sentence</option>
                      <option value="nmod">nominal modifier</option>
                      <option value="nummod">numeric modifier</option>
                      <option value="obj">direct object</option>
                      <option value="obl">oblique argument</option>
                      <option value="orphan">orphaned element (no direct head)</option>
                      <option value="punct">punctuation</option>
                      <option value="reparandum">stricken tokens (reparanda)</option>
                      <option value="vocative">vocative element</option>
                  </select>
              </form>

              <form className="opt2" style={{display: "none"}} id="obl2">
                  <select className="tag2">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":abl">ablative relation</option>
                      <option value=":iobj">indirect object/recipient relation</option>
                      <option value=":lat">allative relation</option>
                      <option value=":loc">static locative relation</option>
                      <option value=":poss">possessor relation</option>
                      <option value=":pred">predicative modifier</option>
                  </select>
              </form>

              <form className="opt2" style={{display: "none"}} id="det2">
                  <select className="tag2">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":ext">extended adnominal demonstrative</option>
                      <option value=":p_nom">postnominal article</option>
                      <option value=":p_adj">postadjectival article</option>
                  </select>
              </form>

              <form className="opt2" style={{display: "none"}} id="aux2">
                  <select className="tag2">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":con">conditional mood marker</option>
                      <option value=":fut">future tense marker</option>
                      <option value=":inf">infinitive clause marker</option>
                      <option value=":opt">optative clause marker</option>
                      <option value=":pass">passive voice marker</option>
                      <option value=":prf">perfect tense marker</option>
                      <option value=":pprf">plusquamperfect tense marker</option>
                  </select>
              </form>

              <form className="opt2" style={{display: "none"}} id="fixed2">
                  <select className="tag2">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":con">conditional mood marker</option>
                      <option value=":fut">future tense marker</option>
                      <option value=":inf">infinitive clause marker</option>
                      <option value=":opt">optative clause marker</option>
                      <option value=":pass">passive voice marker</option>
                      <option value=":prf">perfect tense marker</option>
                      <option value=":pprf">plusquamperfect tense marker</option>
                  </select>
              </form>

              <form className="opt2" style={{display: "none"}} id="mark2">
                  <select className="tag2">
                      <option value="">no extension</option>
                      <option value=":?">any extension</option>
                      <option value=":con">conditional mood marker</option>
                      <option value=":fut">future tense marker</option>
                      <option value=":inf">infinitive clause marker</option>
                      <option value=":opt">optative clause marker</option>
                      <option value=":pass">passive voice marker</option>
                      <option value=":prf">perfect tense marker</option>
                      <option value=":pprf">plusquamperfect tense marker</option>
                  </select>
              </form>
              <br/> <br/><input type="submit" value="write UD tag for parent"   onClick={(e) => uDWrite2(e)}   />
          </form>

</Stack>

      </Grid>
          </Grid>

    </Box>

      <Box>
      <Box mt={2}>
      
      {message && <Alert severity="info">{message}</Alert>}
     
      </Box>

      <CSVReport searchResult={advancedQueryResult}   domain="advanced"/>
           <br/>
          <CSVconLLU searchResult={advancedQueryResult} />

    <br/>

    <PaginationControlledAdvanced queryResult={advancedQueryResult} trans={transcription} />

      </Box>


            </>
    );
  }

